import { useController, type Control, type FieldPath, type FieldValues } from 'react-hook-form';
import { Select, type SelectProps } from '@/components';

/**
 * 選択肢を非同期に読み込む Select（コード値など）。register() だと選択肢の到着前に値が失われるため制御コンポーネントにする。
 */
export function ControlledSelect<T extends FieldValues>({ control, name, ...rest }: { control: Control<T>; name: FieldPath<T> } & Omit<SelectProps, 'value' | 'onChange' | 'name'>) {
  const { field } = useController({ control, name });
  return <Select {...rest} name={field.name} ref={field.ref} value={(field.value as string | null) ?? ''} onChange={(e) => field.onChange(e.target.value)} onBlur={field.onBlur} />;
}
